// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3ve6r","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2MqLl"};